module.exports = __webpack_public_path__ + "static/media/paused-drip.f9eb8498.svg";